this.M = this.M || {};

this.M.DropdownList = function(el, options) {
    var self = this;
    self.el = el;
    self.siteChangeEventHandlers = [];
    self.datasource = options.dataSource;
    self.initialValue = options.initialValue;
    self.hasValue = false;
    self.placeholderText = options.placeholderText;
    self.placeholderDisabled = options.placeholderDisabled;
    if(options.onChange) {
        self.siteChangeEventHandlers.push(options.onChange);
    }
    
    self.el.on("change", function(e) {
        for(var i = 0; i < self.siteChangeEventHandlers.length; i++) {
            self.siteChangeEventHandlers[i](self.el.val(), self.currentData());
        }
    });
    
    self.refresh();
};

this.M.DropdownList.prototype = {
    refresh: function() {
        var self = this;
        self.datasource(function(data) {
            self.data = data;
            self.render();
            if(self.initialValue && !self.hasValue) {
                self.el.val(self.initialValue);
            }
            self.hasValue = true;
            self.el.change();
        });
    },
    render: function() {
        this.el.html(M.templates.dropdownList({
            data: this.data,
            placeholderText: this.placeholderText,
            placeholderValue: this.placeholderValue || "",
            placeholderDisabled: this.placeholderDisabled
        }));
    },
    value: function() {
        return this.el.val();
    },
    currentData: function() {
        for(var i = 0; i < this.data.length; i++) {
            if(this.data[i].value == this.el.val()) {
                return this.data[i].data;
            }
        }
        return null;
    },
    registerSiteChangeEvent: function(handler) {
        this.siteChangeEventHandlers.push(handler);
    },
    unregisterSiteChangeEvent: function(handler) {
        this.siteChangeEventHandlers.remove(handler);
    },
    teardown: function() {
        self.el.off("change");
    }
};